export { CourseWideCardWithReviews } from "./CourseWideCardWithReviews";
